module.exports = __webpack_public_path__ + "img/scroll-mobile.45215b4f.jpg";